import { Container } from "react-bootstrap";

function Maintenance(props) {
  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      <img
        alt="faa-logo"
        src="/faa-logo-big.png"
        width="100"
        className="d-inline-block"
      />
      <h4>Bienvenido al Carnet Digital de la Federacion Aikikai Argentina</h4>
      <br />
      <p>Estamos en MANTENIMIENTO. Intente nuevamente en unos momentos.</p>
    </Container>
  );
}
export default Maintenance;
